import React, { useState } from 'react';
import { Stack, Typography } from '@mui/material';
import { useGetFileLink } from '@/hooks/apiHooks';
import ContentDescription from '@/components/MenuDrawer/MyMenuDrawer/@components/ContentDescription';
import {
  DownloadButton,
  InfoCard,
  InfoLabel,
  InfoRow,
  InfoValue,
  Section,
} from './styles';
import DownloadIcon from '@/public/icons/download.svg';
import { useTranslation } from 'react-i18next';
import { isProd } from '@/constant';

const APP_VERSION = 'v5.1.6';
const RELEASE_DATE = '2026.06.23';

const PORTAL_APK_UUID = isProd
  ? '2e208940-b204-4e1a-8717-8e5e2a8bdff3'
  : '86dbb1b2-a3dd-4591-8b2b-8c06c029c472';

const PortalAppDownload = () => {
  const { t } = useTranslation();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (isDownloading) return;
    setIsDownloading(true);
    try {
      const response = await useGetFileLink(PORTAL_APK_UUID);
      const { url, filename } = response.data ?? {};
      if (url) {
        const blob = await fetch(url).then((r) => r.blob());
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = filename ?? `PortalApp_${APP_VERSION}.apk`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(objectUrl);
      }
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Stack gap={'20px'} sx={{ paddingBottom: '24px' }}>
      <Section>
        <ContentDescription hasVerticalMargin={true} gap={'8px'}>
          <Stack direction={'row'} gap={'10px'} alignItems={'flex-start'}>
            <Stack gap={'4px'}>
              <Typography
                sx={{
                  fontSize: '14px',
                  color: 'var(--dk-text-secondary, #888D96)',
                  lineHeight: '20px',
                }}
              >
                {t('MYPAGE.F&F 임직원용 Portal App (Android) 입니다.')}
              </Typography>
              <Typography
                sx={{
                  fontSize: '14px',
                  color: 'var(--dk-text-secondary, #888D96)',
                  lineHeight: '18px',
                }}
              >
                {t('MYPAGE.아래에서 APK 파일을 다운로드하여 설치해 주세요.')}
              </Typography>
              <Typography> </Typography>
              <Typography
                sx={{
                  fontSize: '14px',
                  color: 'var(--dk-text-secondary, #888D96)',
                  lineHeight: '18px',
                }}
              >
                <br />
                {t(
                  "MYPAGE.iOS는 App Store에서 'F&F Portal'을 검색하여 설치해 주세요.",
                )}
              </Typography>
            </Stack>
          </Stack>
        </ContentDescription>
      </Section>

      <Section>
        <InfoCard>
          <InfoRow>
            <InfoLabel>{t('버전')}</InfoLabel>
            <InfoValue>{APP_VERSION}</InfoValue>
          </InfoRow>
          <InfoRow>
            <InfoLabel>{t('MYPAGE.배포일')}</InfoLabel>
            <InfoValue>{RELEASE_DATE}</InfoValue>
          </InfoRow>
        </InfoCard>
      </Section>

      <Section>
        <DownloadButton onClick={handleDownload} disabled={isDownloading}>
          <DownloadIcon
            width={'20px'}
            height={'20px'}
            stroke={'currentColor'}
          />
          {isDownloading
            ? t('MYPAGE.다운로드 중...')
            : t('MYPAGE.APK 다운로드')}
        </DownloadButton>
      </Section>
    </Stack>
  );
};

export default PortalAppDownload;
